export function MenuIcon() {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.13332 0.800049H12.8M4.13332 4.80005H12.8M4.13332 8.80005H12.8M0.799988 0.800049H0.806654M0.799988 4.80005H0.806654M0.799988 8.80005H0.806654"
        stroke="white"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
